export const BACKEND_URL = 'https://api-dev.gsbsoirikapai.com/query';
export const BACKEND_IMAGE_URL = 'https://api-dev.gsbsoirikapai.com';
export const VALIDITY_EXTEND_TIME = 365;
export const LOCALSTORAGE_TOKEN_KEY = 'token';
export const LOCALSTORAGE_FILTER_PREFERENCE_KEY = 'filterPreference';
export const LOCALSTORAGE_HOMEPAGE_PAGENUMBER = 'homepage_pagenumber';
export const LOCALSTORAGE_FAVOURITES_PAGENUMBER = 'favourites_pagenumber';
// Needs to be in sync with backend. This is a placeholder, used in case backend request failed.
export const PROFILE_REMINDER_EXTENSION_TIME_IN_DAYS = 7;
export const ACKNOWLEDGEMENT_TYPE_TNC = "tnc";
export const ACKNOWLEDGEMENT_TYPE_DECLARATION = "declaration";
export const ACKNOWLEDGEMENT_TYPE_PREVIEW = "preview";